import {getBaseUrl, getCustLinks} from '../../../data/DataStore';
import {getNovSchema} from '../../../utility';
/**
 * @param {JS Object} titleInfo A JS Object containing info about a title
 * @param {string array} searchValues A collection of search values to be appended to the search query.
 */
class SearchByStoryElementsUrlBuilder {

	/**
	 * Generates the url required to make the API call to get titles by story elements.
	 * @param {string} schema
	 * @param {string} baseUrl
	 */
	constructor() {
		this.custLinks = getCustLinks();
	}
	generateUrl(ui, searchValues, profileData) {
		const apiEndpoint = `${getNovSchema()}${window.novSelect.baseUrl || getBaseUrl()}/api/storyMixer/Titles?`;
        const customerInfo = `profile=${profileData.Profile}&password=${profileData.Password}&ui=${ui}&custLinks=${this.custLinks}`;
        const searchParameters = this.generateTermParameters(searchValues);

		const url = `${apiEndpoint}${customerInfo}${searchParameters}`;

		return encodeURI(url);
	}

	generateTermParameters(searchValues) {
		let output = '';
		if(searchValues){
			searchValues.forEach(term => {
				output += `&term=${term}`
			});
		}
		return output;
	}
}

export default SearchByStoryElementsUrlBuilder;



// WEBPACK FOOTER //
// ./src/lib/titleSearch/storyElements/SearchByStoryElementsUrlBuilder.js